import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  tone?: 'dark' | 'light';
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  tone = 'dark',
  align = 'center'
}: SectionHeadingProps) {
  const isLight = tone === 'light';
  return <div className={align === 'center' ? 'text-center' : 'text-left'} data-id="element-159" data-mp="3k186xwdgxaex">
      {eyebrow ? <p className="mb-2 text-[9.5px] font-semibold uppercase tracking-[0.26em] text-gold sm:text-[11px]" data-id="element-160" data-mp="bleqtin1u0ye">
          {eyebrow}
        </p> : null}
      <h2 className={`font-display text-[26px] font-bold uppercase leading-[1.02] tracking-tight sm:text-[34px] lg:text-[40px] ${isLight ? 'text-charcoal' : 'text-cream'}`} data-id="element-161" data-mp="glauthvqxsdy">
        {title}
      </h2>
      <div className={`hairline-gold mt-3 h-px w-20 ${align === 'center' ? 'mx-auto' : ''}`} aria-hidden="true" data-id="element-162" data-mp="uizfopptczj0" />
      {subtitle ? <p className={`mx-auto mt-3 max-w-xl text-[13.5px] leading-snug sm:text-[15px] ${isLight ? 'text-charcoal/70' : 'text-mutedtext'}`} data-id="element-163" data-mp="zbsmdj4uehxq">
          {subtitle}
        </p> : null}
    </div>;
}